export default function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand-compact' : ''}`} aria-label="HOLLA MARKET">
      <span className="brand-mark">H</span>
      {!compact && <span className="brand-name">HOLLA <em>MARKET</em></span>}
    </div>
  );
}
